import { useState, useEffect } from 'react';
import { S3Client } from '../shared/s3Client';

export function contentDispositionAttachment(filename: string): string {
  const sicher = filename.replace(/["\\\r\n]/g, '_');
  return `attachment; filename="${sicher}"`;
}

export function useDateiUrl(key: string | undefined | null, downloadFilename?: string | null): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    let didCancel = false;
    async function loadUrl(key: string) {
      try {
        const disposition = downloadFilename ? contentDispositionAttachment(downloadFilename) : undefined;
        const storageUrl = await S3Client.get(key.replace(/^public\//, ''), disposition);
        if (!didCancel) {
          setUrl(storageUrl);
        }
      } catch (error) {
        console.error('Fehler beim Laden der Datei-URL:', error);
      }
    }
    if (key) {
      void loadUrl(key);
    } else {
      setUrl(null);
    }
    return () => {
      didCancel = true;
    };
  }, [key, downloadFilename]);
  return url;
}
